import React from "react";
import { SobreMi } from "./styled";

export const Sobre = () => {
  return (
    <>
      <SobreMi>SOBRE</SobreMi>
    </>
  );
};
